require('../modules/es6.object.to-string');
require('../modules/web.dom.iterable');
require('../modules/es6.weak-set');
require('../modules/es7.weak-set.of');
require('../modules/es7.weak-set.from');
module.exports = require('../modules/_core').WeakSet;



//////////////////
// WEBPACK FOOTER
// /Users/charles/Projects/codemix/2016/flow-runtime/~/core-js/library/fn/weak-set.js
// module id = 258
// module chunks = 0